import React, { useState, useEffect } from "react";
import { FaMapMarkedAlt } from "react-icons/fa";
import HotelMapModal from "./HotelMapModal";
import "./HotelMapExplorer.css";

export default function HotelMapButton() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener("open-hotel-map", handleOpen);
    return () => window.removeEventListener("open-hotel-map", handleOpen);
  }, []);

  return (
    <>
      <button
        className="sw-map-floating-btn"
        onClick={() => setIsOpen(true)}
        aria-label="Open Sri Lanka Hotel Map"
        title="Explore all Sri Lanka Hotels & Stays on Map"
      >
        <div className="btn-icon-pulse-map">
          <span className="pulse-ring-map" />
          <FaMapMarkedAlt />
        </div>
        <span className="btn-label-map">Sri Lanka Map</span>
      </button>

      <HotelMapModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}
